import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {addLocale, locale} from "primereact/api";
import {InputText} from "primereact/inputtext";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";
import {Tooltip} from "primereact/tooltip";

import HelpComponent from "../HelpComponent";

const _FM_EzeelogListComponent = (props) => {
  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [log, setLog] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const filterTextMatchModes = [
    {label: t('filter_like'), value: 'like'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
  ]
  const filterNumberMatchModes = [
    {label: t('filter_between_number'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const filterDateMatchModes = [
    {label: t('filter_between_date'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('log_first')) || 0,
    rows: Number(localStorage.getItem('log_rows')) || rows,
    page: Number(localStorage.getItem('log_page')) || 0,
    sortField: localStorage.getItem('log_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('log_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('log_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "ezee-event-log" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setLog(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', logSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', logSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm p-button-secondary p-mr-2"
                tooltip={t('show')}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  navigate('/ezee/' + props.accommodationId + '?read=log&logId=' + rowData.id)
                }}/>
      </React.Fragment>
    );
  }

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('log_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('log_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('log_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('log_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('log_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('log_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderLogList])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6 p-col-align-center"}>
          <h2 className={"p-m-0"}>eZee {t('log_list').toLowerCase()}</h2>
        </div>
        <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
          <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
          {localStorage.getItem('log_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('log_filters')
                 localStorage.removeItem('log_sortField')
                 localStorage.removeItem('log_sortOrder')
                 localStorage.removeItem('log_rows')
                 localStorage.removeItem('log_page')
                 localStorage.removeItem('log_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }
          {(Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_ACCOMMODATION_CRUD_WRITE') || Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN')) &&
            <Button type="button"
                    icon={"pi pi-sync"}
                    label={t('ezee_sync_now')}
                    onClick={() => {
                      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "ezee/sync-now",
                        {},
                        {
                          params: {},
                          headers: {
                            'Authorization': 'Bearer ' + Cookies.get("userToken"),
                            "Sys-name": Cookies.get("instanceId"),
                            "Preferred-locale": Cookies.get("language")
                          }
                        })
                        .then(response => {
                          window.App.setState({
                            rerenderLogList: Math.random(),
                          })
                          window.App.toastShow('success', t('success'), response.data.message)
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                    }}
                    className="p-button-warning p-ml-2">
            </Button>
          }
          <span className="p-input-icon-left p-ml-2">
              <i className="pi pi-search"/>
              <InputText id="search"
                         placeholder={t('search')}
                         onChange={(e) => {
                           clearTimeout(window.searchTimeout)
                           window.searchTimeout = setTimeout(function () {
                             localStorage.removeItem('log_filters')
                             localStorage.removeItem('log_sortField')
                             localStorage.removeItem('log_sortOrder')
                             localStorage.removeItem('log_rows')
                             localStorage.removeItem('log_page')
                             localStorage.removeItem('log_first')
                             setLazyParams({
                               ...lazyParams,
                               genericSearch: e.target.value,
                               filters: null,
                             })
                           }, 1000)
                         }}
                         className={""}
              />
            </span>
        </div>
      </div>
      {/* <HelpComponent type={"list_box"} box={"ezee-event-log"}/> */}
      <HelpComponent type={"tab"} tabNumber={3}/>
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={log} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows} emptyMessage={t('empty_message')}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
        onRowDoubleClick={(rowData) => {
          if (!rowData.data.deleted_at_snapshot)
            navigate('/ezee/' + props.accommodationId + '?read=log&logId=' + rowData.id)
        }}
      >

        <Column field="unique_id" sortable header={"Unique id"}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
        ></Column>
        <Column field="sub_booking_id" header={"Sub booking id"}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
        ></Column>
        <Column field="event_type" header={"Event type"}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
        ></Column>
        <Column header={t('reservation')}
                body={(rowData) => {
                  if (rowData.reservation?.association_code) {
                    return (
                      <>
                        {/*<i className={"pi pi-window-maximize"}*/}
                        {/*   onClick={(e) => {*/}
                        {/*     navigate('/ezee/' + props.accommodationId + '/log?update=reservation&reservationId=' + rowData.reservation?.id)*/}
                        {/*   }}*/}
                        {/*></i>*/}
                        {/*&nbsp;*/}
                        <span className={"tt-association-code-ezee-list-info-" + rowData?.reservation?.id + " p-mr-2"}
                              data-pr-tooltip={rowData?.reservation?.association_code}>
                          <i className={"pi pi-info-circle"}
                             style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                        </span>
                        <Tooltip target={".tt-association-code-ezee-list-info-" + rowData?.reservation?.id}/>
                        <span className={"p-badge"}
                              style={{
                                fontSize: '1rem',
                                backgroundColor: rowData?.reservation?.status
                                  ? rowData?.reservation?.status?.toLowerCase() === 'pending'
                                    ? '#dddddd'
                                    : rowData?.reservation?.status?.toLowerCase() === 'confirmed'
                                      ? '#f1eea5'
                                      : rowData?.reservation?.status?.toLowerCase() === 'cancelled'
                                        ? '#f7a2a2'
                                        : rowData?.reservation?.status?.toLowerCase() === 'checked_in'
                                          ? '#3ec0e9'
                                          : rowData?.reservation?.status?.toLowerCase() === 'checked_out'
                                            ? '#0abb87'
                                            : rowData?.reservation?.status?.toLowerCase() === 'no_show'
                                              ? '#8a2be2'
                                              : '#ccc'
                                  : undefined,
                                color: rowData?.reservation?.status
                                  ? rowData?.reservation?.status?.toLowerCase() === 'pending' || rowData?.reservation?.status?.toLowerCase() === 'confirmed'
                                    ? '#5f656b'
                                    : rowData?.reservation?.status?.toLowerCase() === 'no_show'
                                      ? '#fff'
                                      : undefined
                                  : undefined
                              }}>
                          {rowData?.reservation?.association_code?.split(' | ').pop()?.trim()}
                        </span>
                      </>
                    )
                  }
                }}
        ></Column>
        <Column field="created_at_snapshot" sortable header={t('created_at')}
                filter
                filterField={"created_at"}
                sortField={"created_at"}
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.created_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column field="updated_at_snapshot" sortable header={t('updated_at')}
                filterField={"updated_at"}
                sortField={"updated_at"}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.updated_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(_FM_EzeelogListComponent);
